'use client';
import { IRepository, IRepositoryEntry } from '@/types';
import * as Icon from '@/ui/Icon';
import Button from '@/ui/Button';
import { IConfig } from '@/lib/configApi';

const getTabularComparePath = (entry: IRepositoryEntry, repository: IRepository, branch: string) => {
  const repoPath = `/${repository.namespace}/${repository.name}`;
  return `${repoPath}/compare/new?version=${branch}&path=${entry.resource?.path}`;
};

export const CompareLinkButton: React.FC<{
  entry: IRepositoryEntry;
  repository: IRepository;
  version: string;
  small?: boolean;
  config?: IConfig;
}> = ({ entry, repository, version, small, config }) => {
  const comparePath = getTabularComparePath(entry, repository, version);

  if (!config?.compare_enabled) return null;

  return (
    <Button.Basic href={comparePath} small style={{ padding: small ? 5 : 10 }}>
      <Icon.Compare height={small ? 13 : 16} />
    </Button.Basic>
  );
};
